import { useRef, useState } from 'react';
import { isEmpty as _isEmpty } from 'lodash';
import { Transition } from '@headlessui/react';

import { useSwiper } from 'swiper/react';

import YouTube from 'react-youtube';
import NoSSR from '@molecules/NoSSR';

const SimpleYoutube = ({
  videoId,
  poster,
  onPlay,
  setOnPlay,
  setCurrentYoutubeRef,
  bgBlackYN = 'Y',
}) => {
  const ref = useRef();
  return (
    <div className="relative w-full h-[0] pb-[56.26%] overflow-hidden">
      <NoSSR>
        {bgBlackYN == 'Y' && (
          <div className="absolute w-full h-full bg-black" />
        )}
        {!_isEmpty(videoId) && (
          <YouTube
            videoId={videoId}
            className="absolute  w-full h-full  disabledFullscreen"
            opts={{
              width: '100%',
              height: '100%',
              playerVars: {
                autoplay: onPlay,
                rel: 0, //관련 동영상 표시하지 않음 (근데 별로 쓸모 없는듯..)
                modestbranding: 1, // 컨트롤 바에 youtube 로고를 표시하지 않음
              },
            }}
            ref={ref}
            // style={{padding:"5px 0"}}
          />
        )}
        <Transition
          show={!onPlay}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <img
            className="absolute object-cover w-full h-full"
            src={poster}
            alt=""
            style={{ transform: 'translate3d(0,0,0)' }}
          />
          {bgBlackYN == 'Y' && (
            <div className="absolute w-full h-full bg-black bg-opacity-30"></div>
          )}
        </Transition>
      </NoSSR>
    </div>
  );
};

export default SimpleYoutube;
